<div mat-dialog-content class="bodyForm">

  <div class="row infoZona">
    <div class="col">
      <h4 class="textM"><b>{{this.localiser.get("devices.name")}}</b></h4>
      <h4 class="textM">{{this.zona.nombre}}</h4>
    </div>
    <div class="col">
      <h4 class="textM"><b>{{this.localiser.get("devices.floorplan")}}</b></h4>
      <h4 class="textM">{{this.getPlanoNombre(this.zona.idPlano)}}</h4>
    </div>
  </div>

  <h4 class="textM">{{this.localiser.get("zones.lumsList")}}</h4>
  <h4 *ngIf="zona.luminarias.length == 0" class="textM">{{this.localiser.get("zones.noLumsInZone")}}</h4>

  <table class="tablaLuminarias">
    <tr *ngFor="let i of getNumberOfRowsForLuminarias(zona.luminarias); let indexOfelement = index" style="width: 100%; display: flex">
      <td *ngIf="this.zona.luminarias[indexOfelement * 2] != undefined" class="textS+" style="width: 50%; margin: auto">{{this.zona.luminarias[indexOfelement * 2].nombre}}</td>
      <td *ngIf="this.zona.luminarias[(indexOfelement * 2) + 1] != undefined" class="textS+" style="width: 50%; margin: auto">{{this.zona.luminarias[(indexOfelement * 2) + 1].nombre}}</td>
    </tr>
  </table>

</div>

<div mat-dialog-actions style="height: 15%">
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("fade.buttonExit")}}</button>
  </div>
  <div *ngIf="user.getPermiso() != 'Ateneo'" class="col" style="text-align: center">
    <button class="customButtonColor textS+" mat-button (click)="seeOnMap()">{{this.localiser.get("zones.seeOnDevices")}}</button>
  </div>
</div>
